import { Component, Input } from '@angular/core';
import { NavParams, ViewController } from 'ionic-angular';

@Component({
  selector: 'forma-pago-popover',
  templateUrl: 'forma-pago-popover.html'
})
export class FormaPagoPopoverComponent {
  @Input() formasDePago: any[];

  constructor(private viewCtrl: ViewController, private navParams: NavParams) {
    this.formasDePago = this.navParams.get('formasDePago');
  }

  selectFormaPago(item: any) {
    this.viewCtrl.dismiss(item);
  }
}



// WEBPACK FOOTER //
// ./src/pages/forma-pago-popover/forma-pago-popover.ts